import { render, staticRenderFns } from "./confirmation-tooltip.vue?vue&type=template&id=e3628544&"
import script from "./confirmation-tooltip.vue?vue&type=script&lang=js&"
export * from "./confirmation-tooltip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports